export const messages = {
    "shared-link.footer.link.install": "Maksuton {brandName} ‑kokeiluversio",
    "shared-link.footer.link.mobile": "{brandName} for Mobile",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Suojattavat tiedot",
    "shared-link.password-dialog-box.message": "Anna jaettujen tietojen salasana",
    "shared-link.password-dialog-box.hint.password": "Salasana",
    "shared-link.password-dialog-box.message.invalid-password": "Salasana on väärä",
    "shared-link.form.button.open": "Avaa",
    "shared-link.page-not-found.title": "Sivua ei löydy",
    "shared-link.page-not-found.message.main": "Etsimääsi sivua ei löytynyt.",
    "shared-link.page-not-found.message.description": "Linkki saattaa olla vanhentunut tai olet ehkä kirjoittanut osoitteen väärin.",
    "shared-link.page-not-found.message.error": "Virhekoodi: 404",
    "shared-link.restore-file.label.size": "Koko",
    "shared-link.restore-file.button.restore": "Lataa",
    "shared-link.links-table.column.name": "Nimi",
    "shared-link.links-table.column.size": "Koko",
    "shared-link.links-table.action.restore": "Lataa",
    "shared-link.links-table.action.restore-all": "Lataa kaikki",
    "shared-link.side-bar.selected.title:plural": "{count} kohdetta valittu | {count} kohde valittu | {count} kohdetta valittu",
    "shared-link.links-table.label.size": "Koko",
    "shared-link.links-table.message.empty-folder": "Kansio on tyhjä"
};
